const PAGINATION_KEYS = new Set(['page', 'pageSize', 'size', 'limit', 'offset']);

export function buildListParams(paginationModel = {}, filters = {}) {
  const pagination = {};
  const mergedFilters = { ...filters };

  Object.entries(paginationModel).forEach(([key, value]) => {
    if (PAGINATION_KEYS.has(key)) {
      pagination[key] = value;
    } else if (value !== undefined && value !== null && String(value).trim() !== '') {
      mergedFilters[key] = value;
    }
  });

  const cleanedFilters = Object.fromEntries(
    Object.entries(mergedFilters).filter(
      ([, value]) => value !== undefined && value !== null && String(value).trim() !== '',
    ),
  );

  let limit;
  let offset;

  if (pagination.limit !== undefined || pagination.offset !== undefined) {
    limit = pagination.limit;
    offset = pagination.offset ?? 0;
  } else {
    const pageSize = pagination.pageSize ?? pagination.size ?? 20;
    const page = pagination.page ?? 0;
    limit = pageSize;
    offset = page * pageSize;
  }

  return {
    limit,
    offset,
    ...cleanedFilters,
  };
}
